import Swiper from 'swiper/bundle';

(function () {
    const slider = document.querySelector('[data-review-slider]');
    const hideButtons = document.querySelectorAll('.hidden-btn');
    const hiddenContent = document.querySelectorAll('.hidden-content');
    const hiddenDots = document.querySelectorAll('.hidden-dots');

    if (slider) {
        const swiper = new Swiper(slider, {
            spaceBetween: 30,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        });

        swiper.on('slideChange', function () {
            if (hiddenContent) {
                hiddenContent.forEach((cnt, i) => {
                    if (cnt.classList.contains('hidden-content_active')) {
                        cnt.classList.remove('hidden-content_active')
                    }

                    hideButtons[i].innerHTML = hideButtons[i].dataset.show
                    hiddenDots[i].classList.remove('hidden-dots_active');
                })
            }
        });

        if (hideButtons) {
            hideButtons.forEach((btn, i) => {
                btn.addEventListener('click', (e) => {
                    const target = e.target

                    hiddenContent[i].classList.toggle('hidden-content_active')
                    hiddenDots[i].classList.toggle('hidden-dots_active');

                    if (hiddenContent[i].classList.contains('hidden-content_active')) {
                        target.innerHTML = target.dataset.hide
                    } else {
                        target.innerHTML = target.dataset.show
                    }
                })
            })
        }
    }
})();
